import { render, staticRenderFns } from "./performanceForDetails.vue?vue&type=template&id=3b53b3f8&scoped=true&"
import script from "./performanceForDetails.vue?vue&type=script&lang=js&"
export * from "./performanceForDetails.vue?vue&type=script&lang=js&"
import style0 from "./performanceForDetails.vue?vue&type=style&index=0&id=3b53b3f8&lang=stylus&scoped=true&"
import style1 from "./performanceForDetails.vue?vue&type=style&index=1&id=3b53b3f8&lang=stylus&scoped=true&"
import style2 from "./performanceForDetails.vue?vue&type=style&index=2&lang=stylus&"
import style3 from "./performanceForDetails.vue?vue&type=style&index=3&id=3b53b3f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b53b3f8",
  null
  
)

export default component.exports